import { AssignmentTable } from "../components/AssignmentTable";
import { toast } from "../components/toast";
import { useMyAssignments, useSetMyStatus } from "../lib/proofers";

/** A proofer's own view — the jobs assigned to them, as a spreadsheet (one line
 * per project, like the Excel log it replaces), with the granted essentials and
 * a submit action. The only screen a proofer-only account sees. */
export function MyWork() {
  const { data, isLoading } = useMyAssignments();
  const setStatus = useSetMyStatus();
  const onStatus = (id: string, status: string) =>
    setStatus.mutate({ id, status }, {
      onSuccess: () =>
        toast(status === "submitted" ? "Marked complete" : "Status updated", "success"),
      onError: (e: unknown) => toast((e as Error)?.message || "Couldn't update", "error"),
    });
  const items = data?.assignments ?? [];
  return (
    <div className="pl-page wide">
      <header className="pl-head">
        <h1>My Work</h1>
        <p className="muted">The jobs assigned to you — set your status as you go; your admin sees it on the board.</p>
      </header>
      {isLoading ? (
        <p className="muted">Loading…</p>
      ) : items.length === 0 ? (
        <div className="pl-empty">Nothing assigned to you yet.</div>
      ) : (
        <AssignmentTable items={items} onStatus={onStatus} />
      )}
    </div>
  );
}
